import { handleActions } from 'redux-actions';
var handler = handleActions({}, {});
export default handler;
//# sourceMappingURL=tierManageContentReducer.js.map